import React from 'react';

import Technician from './Technician';

const Technicians = props => {
    var rendered = [];
    /*
        {
            "techID": "667177",
            "techName": "some person"
        },
     */
    for (var i = 0; i < props.technicians.length; i++) {
        var technician = props.technicians[i];
        if (technician['techName'].toLowerCase().indexOf(props.term) >= 0) {
            var push = true;
            if (props.mode == 'event' && props.assigned.indexOf(technician.techName) >= 0) push = false;
            if (push) {
                rendered.push(
                    <Technician {...props}
                        key={'technician-' + technician.techID + '-' + props.mode + '-' + i}
                        assignTechnicianToEvent={props.mode == 'event' ? props.assignTechnicianToEvent.bind(null, i) : null}
                        technician={technician}/>
                );
            }
        }
    }

    return <div>{rendered}</div>;
}

export default Technicians;
